import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import { calculateImpressionsFromBudget } from '../../../../UploadAdCreative/ImpressionsBudgetSection/helpers'
import { getBudgetType } from '../../../../LineItemForms/typeHelpers'

import { rightSelector } from '../../../../../../modules/selectors/rights'

import { BUDGET_DAILY, BUDGET_LIFETIME } from '../../../../fields'

const LineItemImpressionsBudgetPreview = ({ lineItem }) => {
  const { t } = useTranslation()

  const right = useSelector(rightSelector)
  const { bid_cap: rightBidCap } = right

  const { budget_lifetime: budgetLifetime, budget_daily: budgetDaily } = lineItem
  const budgetType = getBudgetType(budgetLifetime, budgetDaily)

  const impressionsLifetime = calculateImpressionsFromBudget({
    budget: budgetLifetime,
    rightBidCap
  })

  const impressionsDaily = calculateImpressionsFromBudget({
    budget: budgetDaily,
    rightBidCap
  })

  if (budgetType === BUDGET_LIFETIME) {
    return (
      <span>
        {impressionsLifetime} ({t('Lifetime')})
      </span>
    )
  }

  if (budgetType === BUDGET_DAILY) {
    return (
      <span>
        {impressionsDaily} ({t('Daily')})
      </span>
    )
  }

  return null
}

LineItemImpressionsBudgetPreview.propTypes = {
  lineItem: PropTypes.object.isRequired
}

export default LineItemImpressionsBudgetPreview
